export default "__VITE_ASSET__D0YPlOu6__"